export default "__VITE_ASSET__DY4JriBm__"